import styled from 'styled-components'

import {
  StyledWrapper as StyledBookingPatternWrapper,
} from 'module/RegistrationForm/RegistrationForm/components/BookingPattern/BookingPatternStyled'

export const StyledWrapper = styled.div`
  * {
    pointer-events: none;
    user-select: none;
  }

  button, #data-terms, ${StyledBookingPatternWrapper} * {
    pointer-events: auto;
    user-select: auto;
  }
`
